'use client';
import React, { useState, useEffect } from 'react';
import Homep from '@/app/componenets/Homep';
import Hero from '@/app/services/special-events/hero';
import Content from '@/app/services/special-events/content';
import THirdSlider from '@/app/services/special-events/thirdSlider';
import Banners from '@/app/services/special-events/Banner';
import Distination from '@/app/services/special-events/distination';
import LimoService from '@/app/services/special-events/limoService';
import MainData from '@/app/data/MainState';
import TawkTo from '../../componenets/Tawko';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
import Head from 'next/head';
function page({ params }) {
  console.log(MainData, params, 'hellllllll');
  const [image, setImage] = useState('consumerspecialevent');
  const [title, setTitle] = useState('Parties, Get-to-Gather and More');
  const [subtitle, setSubtitle] = useState(
    'Car Service for Special Events:    '
  );
  const mapping = MainData?.find((p) => p?.link === params.statesPage);
  console.log(mapping, 'mapping');

  useEffect(() => {
    if (mapping) {
      const data = mapping?.data[0];
      setImage(data.hero_image);
      setTitle(data.title);
      setSubtitle(data.subtitle);
    }
  }, [mapping]);

  console.log(image, 'iiiii');

  return (
    <div>
      <title>Luxurious Car Service for Your Special Events and Occasions</title>
      <meta
        name="description"
        content="Experience unparalleled luxury at your special events with Prestige Ride's highly
        comfortable cars and skilled chauffeur service. Happy events!"
      />
      <meta name="robots" content="index, follow" />
      <meta name="keywords" content="" />
      <link
        rel="canonical"
        href="https://www.prestigeride.com/services/special-events"
      />

      {/* <Try/> */}
      {/* <Hero /> */}
      <TawkTo />
      <Navbar />
      <Homep image={image} title={title} subtitle={subtitle} />

      <Content />
      <THirdSlider />
      <Banners />
      <Distination />
      <LimoService />
      <Footer />
      {/* <Book/> */}
      {/* <Jfk/> */}
      {/* <LastSlider/> */}
      {/* <InnerText/> */}
    </div>
  );
}

export default page;
